import { render } from "./HeroSectionPage.vue?vue&type=template&id=f4705652&scoped=true"
import script from "./HeroSectionPage.vue?vue&type=script&lang=js"
export * from "./HeroSectionPage.vue?vue&type=script&lang=js"

import "./HeroSectionPage.vue?vue&type=style&index=0&id=f4705652&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4705652"]])

export default __exports__